import { useState, useEffect, useMemo, useRef } from 'react'
import "./style.scss"
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import 'quill-paste-smart';
import EditorTemplateModal from "../../modals/EditorTemplateModal";

const Index = ({ setExpandEditorModal, image, images, setImages, removeEmptyParagraphs }) => {
const quillRef = useRef(null);
const toolbarId = useRef(`toolbar-${Math.random().toString(36).substr(2, 9)}`).current;
const [showTemplateModal, setShowTemplateModal] = useState(false);
const [savedPosition, setSavedPosition] = useState(null)

  useEffect(() => {
    if (!quillRef.current) return;
    const quill = quillRef?.current?.getEditor();
    const tooltip = quill.theme.tooltip;
    const originalShow = tooltip.show;
    tooltip.show = function () {
      const range = quill.getSelection();
      if (!range) return;
      const format = quill.getFormat(range);
      if (format.customLink) {
        return;
      }

      originalShow.apply(this, arguments);
    };
  }, [quillRef])

    const openTemplateModal = () => {
        const quill = quillRef.current.getEditor();
        const range = quill.getSelection();
        if (!range) return;
        const position = range ? range.index : quill.getLength();
        setShowTemplateModal(true);
        setSavedPosition(position)
    }

    const onInsertTemplate = (content) => {
        const quill = quillRef.current.getEditor();
        const quillContainer = quill.root
        quill.clipboard.dangerouslyPasteHTML(savedPosition, content);
        const tempDiv = document.createElement("div")
        tempDiv.innerHTML = content
        const insertedLength = tempDiv.innerText.length
        const bounds = quill.getBounds(savedPosition + insertedLength);
        quillContainer.scrollTop = (bounds.top - quillContainer.clientHeight / 2)
        setShowTemplateModal(false);
        setSavedPosition(null)
    }

    const modules = useMemo(() => ({
        toolbar: {
            container: `#${toolbarId}`,
            handlers: {
                template: () => {
                    openTemplateModal();
                },
            }
        },
        keyboard: {
            bindings: {
                handleEnter: {
                    key: [13, 'meta+enter'],
                    handler: function (range) {
                        const [line] = this.quill.getLine(range.index);
                        const lineText = line.domNode.textContent.trim();
                        if (lineText === '') return false;
                        return true;
                    },
                },
            },
        },
    }), []);



    return (
        <div className="small-modal-wrapper">
            <div className="expand-modal-content">
                <span className='close' onClick={() => {
                    setExpandEditorModal(false)
                }}><i className="fas fa-times"></i></span>
                <h2>{image}</h2>
                <div className="form-container">
                    <div>
                        <div className="editor-container">
                            <div className='quill editor'>
                                <div id={toolbarId}>
                                    <button className="ql-bold" />
                                    <button className="ql-italic" />
                                    <button className="ql-underline" />
                                    <button className="ql-blockquote" />
                                    <button className="ql-link" />
                                    <button className="ql-list" value="bullet" />
                                    <button className="ql-script" value="sub" />
                                    <button className="ql-script" value="super" />
                                    <button className="ql-template"><i className="fas fa-list-alt"></i></button>
                                </div>
                                <ReactQuill
                                    ref={quillRef}
                                    theme="snow"
                                    modules={modules}
                                    placeholder='Type Here...'
                                    preserveWhitespace
                                    onChange={(content, delta, source, editor) => {
                                        const newImages = images.map((item) => {
                                            if (item?.name === image) {
                                                return {
                                                    ...item,
                                                    methods: removeEmptyParagraphs(editor.getHTML())
                                                }
                                            } else {
                                                return item
                                            }
                                        })
                                        setImages(newImages)
                                    }}
                                    value={images.find((item) => item?.name === image)?.methods}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <button className='btn transparent'
                        onClick={() => setExpandEditorModal(false)
                        }>Close
                    </button>
                </div>
            </div>
            {showTemplateModal && <EditorTemplateModal setShowTemplateModal={setShowTemplateModal} setSavedPosition={setSavedPosition} savedPosition={savedPosition} onInsertTemplate={onInsertTemplate} /> }
        </div>
    )
}

export default Index